require('./landing.scss');
import {submitMailCta} from "../utils";

const secondSliderSection = () => {

    let currentIndex = 0;
    const items = $('.testimonials-second-slider .testimonial-item');
    const dots = $('.testimonials-indicators .dot');

    setInterval(() => {
        currentIndex = (currentIndex + 1) % items.length;
        $('.testimonials-second-slider').animate({
            scrollLeft: currentIndex * $('.testimonials-second-slider').width()
        }, 600, () => {
            dots.removeClass('active').eq(currentIndex).addClass('active');
        });

    }, 4000);
};

const initSlider = (baseClass, getScrollAmount) => {
        const slider = $(`${baseClass} .slider`);
        const $buttons = {
            next: $(`${baseClass} .next`),
            prev: $(`${baseClass} .prev`)
        };
        const gap = parseFloat(getComputedStyle(slider[0]).gap) || 0;

        const updateButtons = () => {
            const maxScroll = slider[0].scrollWidth - slider[0].clientWidth;
            $buttons.prev.toggleClass('slider-button-disable', slider.scrollLeft() <= 0);
            $buttons.next.toggleClass('slider-button-disable', slider.scrollLeft() >= maxScroll);
        };

        const applySnapScroll = (direction) => {
            if (window.innerWidth > 768) {
                if (direction === 'next') {
                    slider.children().css('scroll-snap-align', 'end');
                } else {
                    slider.children().css('scroll-snap-align', 'start');
                }
            }
        }

        $.each($buttons, (direction, $button) => {
            $button.click(() => {
                const scrollAmount = getScrollAmount(slider) + gap;
                slider.animate({scrollLeft: (direction === 'next' ? '+=' : '-=') + scrollAmount + 'px'}, 300, updateButtons);
                applySnapScroll(direction);
            });
        });

        slider.on('scroll', updateButtons);
        updateButtons();
    }
;

const getScrollAmountFirstSlider = (slider) => {
    if (window.innerWidth <= 768) {
        return slider.width();
    } else if (window.innerWidth <= 1200) {
        return slider.width() / 2;
    } else {
        return slider.width() / 3;
    }
};

$(() => {
    submitMailCta();
    secondSliderSection();
    initSlider('.testimonials-section', getScrollAmountFirstSlider);
    initSlider('.client-case-studies', getScrollAmountFirstSlider);
    if (document.documentElement.lang.startsWith('en')) {
        const myModalEl = document.getElementById('youtubeVideoModal')
        myModalEl.addEventListener('hidden.bs.modal', event => {
            const videoElement = document.querySelector('lite-youtube');
            if (videoElement.classList.contains('lyt-activated')) {
                const iframe = videoElement.querySelector('iframe');
                iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
            }
        })
    }

});